/* global  */ // tUrl等のグローバル変数を宣言する

import './_top.js'
import './_mid.js'
// import './_form.js'

import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
// 画面に入った監視対象に.animatedを付加
// Intersection Observer
window.intObs = function () {
  if (!document.getElementsByClassName('js-in')[0]) {
    return
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '-20px 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('animated')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}
window.intObs()

//   ####  ######    ###    #####  #####
//  ##       ##     ## ##   ##     ##
//   ###     ##    ##   ##  #####  #####
//     ##    ##    #######  ##     ##
//  ####     ##    ##   ##  ##     ##
if (document.getElementById('topStaff')) {
  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars
  const slideItem = document.getElementById('topStaff')
  const sliderName = 'topStaff'
  const topStaffSwiper = new Swiper(slideItem, {
    // init: false, // 自動で初期化しない（topStaffSwiper.init()で初期化）
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 1000, // アニメ速度
    loop: false, // ループ
    preloadImages: false, // スライド内の画像を読み終えてから開始
    slidesPerView: 1.1, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化

    centeredSlides: true, // 中央のスライドを基準にする

    spaceBetween: 25, //スライド同士の間隔を空ける
    navigation: {
      nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    },

    breakpoints: {
      // 指定px以上でオプション切り替え
      769: {
        centeredSlides: false, // 中央のスライドを基準にする
        slidesPerView: 3, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
        spaceBetween: 40, //スライド同士の間隔を空ける
      },
    },
  })
}
